module.exports = __webpack_public_path__ + "static/media/logo.4e59e143.png";